import * as types from "./actionTypes";
import axios from "axios";

export const adminSignup = (payload) => (dispatch) => {
  dispatch({ type: types.ADMIN_SIGNUP_REQUEST });
  return axios({
    method: "post",
    url: "/api/v1/auth/register/admin",
    baseURL: "http://54.206.125.24:8888",
    data: payload,
  })
    .then((res) => {
      console.log(res);
      dispatch({ type: types.ADMIN_SIGNUP_SUCCESS, payload: res.data });
      return res.data;
    })
    .catch((err) => {
      dispatch({ type: types.ADMIN_SIGNUP_FAILURE, payload: err });
    });
};

export const studentSignup = (payload) => (dispatch) => {
  dispatch({
    type: types.STUDENT_SIGNUP_REQUEST,
    payload: true,
  });
  return axios.post("http://54.206.125.24:8888/api/v1/auth/register/user", payload)
    .then((res) => {
      dispatch({
        type: types.STUDENT_SIGNUP_SUCCESS,
        payload: res.data,
      });
      return res.data;
    })
    .catch((err) => {
      dispatch({
        type: types.STUDENT_SIGNUP_FAILURE,
        payload: true,
      })
    })
};

export const userLogin = (payload) => (dispatch) => {
  dispatch({ type: types.USER_LOGIN_REQUEST });
  return axios.post("http://54.206.125.24:8888/api/v1/auth/login", payload)
    .then((res) => {
      dispatch({
        type: types.USER_LOGIN_SUCCESS,
        payload: res.data,
      })
      console.log("login user data", res.data);
      return types.USER_LOGIN_SUCCESS;
    })
    .catch((err) => {
      console.log(err.message);
      dispatch({
        type: types.USER_LOGIN_FAILURE,
      })
    })
};
